<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>EXAMINATION SCHEDULE</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image" /></div>
</div>

<div class="blog-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="about-text-container">
                    <h4
                        style="
                            background: #29176d;
                            color: white;
                            padding: 21px;
                            margin-bottom: 15px;
                        "
                    >
                        Regular & Back Paper Date Sheet July 2025 (Semester
                        Mode)
                    </h4>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/July2025DateSheet/Theory First Sem.pdf"
                            >REGULAR & BACK PAPER DATE SHEET:- FIRST SEMESTER</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/July2025DateSheet/Theory Second Sem.pdf"
                            >REGULAR & BACK PAPER DATE SHEET:- SECOND
                            SEMESTER</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/July2025DateSheet/Theory Third Sem.pdf"
                            >REGULAR & BACK PAPER DATE SHEET:- THIRD SEMESTER</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/July2025DateSheet/Theory Fourth Sem.pdf"
                            >REGULAR & BACK PAPER DATE SHEET:- FORTH SEMESTER</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/July2025DateSheet/Theory Fifth Sem.pdf"
                            >REGULAR & BACK PAPER DATE SHEET:- FIFTH SEMESTER</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/July2025DateSheet/Theory Sixth Sem.pdf"
                            >REGULAR & BACK PAPER DATE SHEET:- SIXTH SEMESTER</a
                        >
                    </p>
                    <h4
                        style="
                            background: #29176d;
                            color: white;
                            padding: 21px;
                            margin-bottom: 15px;
                        "
                    >
                        Practical Date Sheet July 2025 (Semester Mode)
                    </h4>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/July2025DateSheet/Practical First Sem.pdf"
                            >PRACTICAL DATE SHEET:- FIRST SEMESTER</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/July2025DateSheet/Practical Second Sem.pdf"
                            >PRACTICAL DATE SHEET:- SECOND SEMESTER</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/July2025DateSheet/Practical Third Sem.pdf"
                            >PRACTICAL DATE SHEET:- THIRD SEMESTER</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/July2025DateSheet/Practical Fourth Sem.pdf"
                            >PRACTICAL DATE SHEET:- FORTH SEMESTER</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/July2025DateSheet/Practical Fifth Sem.pdf"
                            >PRACTICAL DATE SHEET:- FIFTH SEMESTER</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/July2025DateSheet/Practical Sixth Sem.pdf"
                            >PRACTICAL DATE SHEET:- SIXTH SEMESTER</a
                        >
                    </p>
                    <h4
                        style="
                            background: #29176d;
                            color: white;
                            padding: 21px;
                            margin-bottom: 15px;
                        "
                    >
                        Practical Date Sheet May 2025 (Annual Mode)
                    </h4>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/MAY2025AnnualDateSheet/PRACTICAL DATE SHEET - FIRST YEAR.pdf"
                            >PRACTICAL DATE SHEET:- FIRST YEAR</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/MAY2025AnnualDateSheet/PRACTICAL DATE SHEET - SECOND YEAR.pdf"
                            >PRACTICAL DATE SHEET:- SECOND YEAR</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/MAY2025AnnualDateSheet/PRACTICAL DATE SHEET - THIRD YEAR.pdf"
                            >PRACTICAL DATE SHEET:- THIRD YEAR</a
                        >
                    </p>
                    <h4
                        style="
                            background: #29176d;
                            color: white;
                            padding: 21px;
                            margin-bottom: 15px;
                        "
                    >
                        Back Paper Date Sheet May 2025 (Annual Mode)
                    </h4>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/MAY2025AnnualDateSheet/BACK PAPER DATE SHEET - FIRST YEAR.pdf"
                            >BACK PAPER DATE SHEET:- FIRST YEAR</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/MAY2025AnnualDateSheet/BACK PAPER DATE SHEET - SECOND YEAR.pdf"
                            >BACK PAPER DATE SHEET:- SECOND YEAR</a
                        >
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="assets/documents/MAY2025AnnualDateSheet/BACK PAPER DATE SHEET - THIRD YEAR.pdf"
                            >BACK PAPER DATE SHEET:- THIRD YEAR</a
                        >
                    </p>
                    
                </div>
            </div>
        </div>
    </div>
</div>
